import { FieldRegistryConfig } from "../../types";
import { YesNoFieldControl } from "./YesNoFieldControl";
import { $t } from "../../../utils/intl";
import { yesNoFieldText } from "./YesNoFieldControl.text";
import { defaultToReviewString } from "../review/reviewString.helpers";

type YesNoFormValue = boolean | string;

export const yesNoFieldConfig: FieldRegistryConfig<YesNoFormValue> = {
  icon: "yes-and-no",
  control: YesNoFieldControl,
  prefill: ({ value }) => {
    const trueValues = ["yes", "true", "1"];
    return trueValues.includes(value.toLowerCase());
  },

  toReviewString: (value, appField, preferences) => {
    const isYes =
      typeof value === "boolean"
        ? value
        : defaultToReviewString(value, appField, preferences) === "Yes";

    return isYes ? $t(yesNoFieldText.yes) : $t(yesNoFieldText.no);
  },
};
